import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addAllCatAnimationToSprite } from '../AnimationManager';
import ManRocket from '../game/ManRocket';
import Rocket from '../game/Rocket';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import SelectLevelScreen from './SelectLevelScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ClockScreen from './ClockScreen';
import GameScreen from './GameScreen';
import gameData from '../gameData';

export default class AnimationScreen extends Phaser.Scene {
  static get KEY() { return 'AnimationScreen'; }

  constructor() {
    super({ key: AnimationScreen.KEY });
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._background_level0, this).setOrigin(0);

    this.input.on(Phaser.Input.Events.POINTER_DOWN, this.transitionOut, this);

    this.man = ABCyaPhaser.Images.addImage(-200, this.scale.height / 2, UIAssetKeys._man, this).setAngle(-20);

    ABCyaPhaser.Tweens.addTween(this.man, 700, { delay: 700, onStart: () => this.playNoSound(),angle: 30, x: this.man.x + 200, completeDelay: 3000 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.man, 700, { x: this.man.x - 300, angle: 0 }, Phaser.Math.Easing.Linear);
    });

    this.catAnimation = this.add.sprite(this.scale.width / 2 - 520, this.scale.height / 2 - 140,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._cat_0);
    this.catAnimation.scale = 1.6;
    addAllCatAnimationToSprite(this.catAnimation);

    ABCyaPhaser.Tweens.addTween(this.catAnimation, 2500, { delay: 700, onStart: () => this.catJumpShipSound(), x: this.catAnimation.x + 700 }, Phaser.Math.Easing.Linear, () => {
      this.removeCatAnimation();
      this.time.delayedCall(3000, this.manRocketAnimation, null, this);
    });

    this.rocket = new Rocket(this);
    this.add.existing(this.rocket);
    this.rocket.x = this.scale.width / 2 + 30;
    this.rocket.y = this.scale.height / 2 - 200;

    this.time.delayedCall(11000, this.transitionOut, null, this);
  }

  transitionOut () {
    this.tweens.killAll();
    this.time.clearPendingEvents();
    this.time.removeAllEvents();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._transition, this);

    // so graphics don't spin with background
    this.rocket.destroy();
    this.manRocket?.destroy();
    this.man.destroy();

    const totalRotation = -2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 0 }, Phaser.Math.Easing.Linear, () => this.cleanUp());
  }

  cleanUp () {
    if (this.catSound) {
      this.catSound.destroy();
    }

    if (this.noSound) {
      this.noSound.destroy();
    }

    if (ABCyaLib.Environment.instance.gameConfig.levelsOverride === null) {
      this.scene.start(SelectLevelScreen.KEY);
    }
    else if (ABCyaLib.Environment.instance.gameConfig.gameMode === null) {
      // go to the clock selection screen if needed
      this.scene.start(ClockScreen.KEY);
    }
    else {
      // go directly to the game
      gameData.CLOCK_IS_ANALOG = ABCyaLib.Environment.instance.gameConfig.gameMode === 'analog';
      this.scene.start(GameScreen.KEY);
    }
  }

  playNoSound () {
    this.noSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._no, this.noSound);
  }

  catJumpShipSound () {
    this.catSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._cat_jump_ship, this.catSound);
  }

  manRocketAnimation () {
    this.manRocket = new ManRocket(this);
    this.add.existing(this.manRocket);
    this.manRocket.x = this.scale.width / 2 - 500;
    this.manRocket.y = this.scale.height / 2 + 500;

    this.manRocket.liftOffIntro();
  }

  removeCatAnimation () {
    this.catAnimation.destroy();
  }
}